/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from 'graphql-tag';

export const GET_MANUFACTURER = gql`
query GetMyOrganization {
    getNetworkOperatorOrganization {
      _id
      telephone
      name
      description
      nameKey
      email
      sameAs
      address {
        country
        zipcode
        state
        city
        addressLine1
        addressLine2
      }
      fullAddress
      creator
      logo
      type
      orgType
      did
      pk
      identityProviderType
      website
      socialLinks {
        type
        url
      }
    }
  }
`;
